import { render, staticRenderFns } from "./descriptive.vue?vue&type=template&id=5b54a00c&"
import script from "./descriptive.vue?vue&type=script&lang=js&"
export * from "./descriptive.vue?vue&type=script&lang=js&"
import style0 from "./descriptive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports